module.exports = __webpack_public_path__ + "static/media/sf_attraction_attpark.90d25f1a.jpg";